import { Navigate } from "react-router-dom";

import { isMenuItemEnabled } from "../../../config/appsConfig";
import { useMenuEntitlement } from "../../../hooks/useEntitlement";
import { MENU, activosDefaultRoute, type ActivosNavItem } from "../config";
import { ACTIVOS_APP_ID, ACTIVOS_BASE, ACTIVOS_CATEGORY_ID } from "../paths";

// Sub-menú visible de Activos: lo trae el preset del tenant (`isMenuItemEnabled`)
// Y la sesión tiene su menú (`menu:activos.<id>`). Archivo común, idéntico en
// CC-CONSOLE y WAYAK.
export function useActivosMenu(): ActivosNavItem[] {
  const canSeeMenuItem = useMenuEntitlement(ACTIVOS_APP_ID);
  return MENU.filter((item) => isMenuItemEnabled(ACTIVOS_CATEGORY_ID, ACTIVOS_APP_ID, item.id) && canSeeMenuItem(item.id));
}

/** `/activos` → la primera sección que la sesión SÍ tiene (no siempre Inventario). */
export function ActivosIndexRedirect() {
  const visible = useActivosMenu();
  return <Navigate to={visible.length ? `${ACTIVOS_BASE}/${visible[0].id}` : activosDefaultRoute} replace />;
}
